import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { optOut } from '@/lib/outreach';

/**
 * The refusal link of a first e-mail (03/11/2026): public, one button. Once
 * confirmed, nobody of this company's workspace writes to the address again.
 */
export const OptOutPage = () => {
  const { token = '' } = useParams();
  const [state, setState] = useState<{ sender: string | null; company: string | null; email: string; done: boolean } | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    void optOut(token, 'read')
      .then((payload) => setState({ sender: payload.sender ?? null, company: payload.company ?? null, email: payload.email ?? '', done: Boolean(payload.done) }))
      .catch((cause: unknown) => setError(cause instanceof Error ? cause.message : 'Lien illisible.'));
  }, [token]);

  const confirm = async () => {
    setBusy(true);
    try {
      const payload = await optOut(token, 'confirm');
      setState((current) => current && { ...current, done: Boolean(payload.done) });
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'Le refus n’a pas pu être enregistré.');
    } finally {
      setBusy(false);
    }
  };

  const from = [state?.sender, state?.company].filter(Boolean).join(', ');
  return (
    <main className="flex min-h-screen items-center justify-center bg-domino-warm px-4">
      <div className="w-full max-w-md rounded-2xl border border-domino-cardBorder bg-domino-white p-6 text-center">
        {error && <p role="alert" className="text-sm text-domino-inkSoft">{error}</p>}
        {!error && !state && <div className="mx-auto h-5 w-48 animate-pulse rounded bg-domino-warm" />}
        {state && !state.done && (
          <>
            <h1 className="font-display text-lg font-semibold text-domino-ink">Ne plus recevoir de messages</h1>
            <p className="mt-2 text-sm text-domino-inkSoft">{state.email}{from ? ` · ${from}` : ''}</p>
            <button type="button" disabled={busy} onClick={() => { void confirm(); }}
              className="mt-5 rounded-xl bg-domino-aubergine px-4 py-2 text-sm font-semibold text-white disabled:opacity-60">
              Confirmer
            </button>
          </>
        )}
        {state?.done && (
          <>
            <h1 className="font-display text-lg font-semibold text-domino-ink">C’est noté</h1>
            <p className="mt-2 text-sm text-domino-inkSoft">{state.email}</p>
          </>
        )}
      </div>
    </main>
  );
};
